import type { ShopProduct } from '../../mocks/shopProducts';

export function isAppearanceSelectionOptionalProductCategory(category: ShopProduct['category']) {
  return category === 'Accessories' || category === 'Hair' || category === 'Nails';
}
